import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ClientPortal from './pages/ClientPortal';
import InstallerDashboard from './pages/InstallerDashboard';

const isPortalDomain = window.location.hostname === 'portal.smarttechutah.com';

function App() {
  return (
    <Router>
      <Routes>
        {isPortalDomain ? (
          <Route path="*" element={<ClientPortal />} />
        ) : (
          <>
            <Route path="/" element={<InstallerDashboard />} />
            <Route path="/dashboard" element={<InstallerDashboard />} />
            <Route path="/portal" element={<ClientPortal />} />
            <Route path="/portal/:clientId" element={<ClientPortal />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
